export var APPLICATION_MISSING_BACKGROUND = '#FFC9AD';
export var APPLICATION_REVIEWING_BACKGROUND = '#A6B5FC';
export var APPLICATION_NOT_APPROVED_BACKGROUND = '#FFB3B5';
export var APPLICATION_COMPLETED_BACKGROUND = '#B4F48F';
export var APPLICATION_MISSING_ICON = '#7D4400';
export var APPLICATION_REVIEWING_ICON = '#00358A';
export var APPLICATION_NOT_APPROVED_ICON = '#930013';
export var APPLICATION_COMPLETED_ICON = '#466819';
export var STUDENT_RECORDS_PRIMARY = '#3E8FCD';
export var STUDENT_RECORDS_BORDER = '#C8D3E2';
export var STUDENT_RECORDS_ATTACHMENT_BACKGROUND = '#EFF2F3';
export var STUDENT_RECORDS_PLACEHOLDER = '#EDF1F5';